import React from 'react';

import { type User } from 'generated/graphql';

import styles from './Icon.module.scss';

interface IconProps {
  user?: User;
  inverted?: string | null;
}

const Icon: React.FC<IconProps> = ({ user, inverted }) => {
  return (
    <div
      data-testid="icon"
      className={`${styles.Outer} ${!user ? 'LoadingCoverImage' : ''} ${inverted ? styles.Inverted : ''}`}
    >
      {user?.givenName ? user.givenName.charAt(0) : 'A'}
      {user?.familyName ? user.familyName.charAt(0) : 'B'}
    </div>
  );
};

export default Icon;
